<script>
  export let background = 'white';
  export let border = true;
</script>

<div class="bg-{background}  rounded  {border ? 'border-gray-200  border' : ''}  text-gray-700  px-4  py-2  overflow-x-scroll  md:overflow-auto">
  <slot></slot>
</div>
